const chatChipNonVisblePages = [
  "experts-services",
  "experts-request",
  "reseller",
  "graphicDesign-Dashboard",
  "qr",
  "logomaker",
  "/acc/",
  "/xs/",
  "/env/",
  "/pdc/",
  "/apdc"
];
const inlineButtonChatPages = [
  "ubikstudio",
  "studio",
  // design button,
  "design",
  "order-help-v2"
];

export { chatChipNonVisblePages, inlineButtonChatPages };
//# sourceMappingURL=src-config-chat-config.js.map
